import React, { FC, useRef } from 'react';
import cn from 'classnames';
import _ from 'lodash';

import { useOnClickOutside } from 'client/hooks';

import Icon from '../../Icon';

import css from './PopupWrapper.module.scss';

type Props = {
  className?: string;
  onClose?: () => void;
  children: JSX.Element;
  withCloseIcon?: boolean;
  showOverlay?: boolean;
};

const PopupWrapper: FC<Props> = ({ onClose = _.noop, children, withCloseIcon = true, className = '', showOverlay }) => {
  const containerRef = useRef(null);

  useOnClickOutside(containerRef, onClose);

  return (
    <div
      className={cn(
        css.backdrop,
        className.split(' ').map((c) => (c in css ? css[c as keyof typeof css] : c)),
        { [css.showOverlay]: showOverlay },
      )}
    >
      <div className={css.overlay}></div>
      <div className={css.container} ref={containerRef}>
        {withCloseIcon && (
          <div className={css.close}>
            <button onClick={onClose}>
              <Icon type="close" color="#000" />
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default PopupWrapper;
